export enum RateType {
  Doctor = 'doctor',
  Clinic = 'lpu',
}
